module.exports = __webpack_public_path__ + "media/images/products/products/h1-5c100e0dae5bfe1a6ab595b8c803ca2d.jpg";